import { TRIAL_SHOW_CASE_STEPS } from '@/enum/trial/trialShowCaseSteps.enum';

export const filterBU = (path: string) => {
  const { BASE_URL } = process.env;
  const regex = /^\//;

  const [BU] = path
    .replace(BASE_URL as string, '')
    .replace(regex, '')
    .split('/');

  return BU;
};

export class ShowCaseHelper {
  private static readonly SHOWCASE_STEPS_KEY = 'showCaseStepsState';

  private static readonly NUMBER_OF_NEEDED_STEPS = 4;

  private static readonly TRIAL_CONTROL_DATE = new Date('2022-10-03T18:42:00-03:00').toISOString();

  private static getShowCaseState(): TRIAL_SHOW_CASE_STEPS[] {
    const currentValue = localStorage.getItem(this.SHOWCASE_STEPS_KEY);
    return currentValue ? JSON.parse(currentValue) : [];
  }

  private static setShowCaseState(step: TRIAL_SHOW_CASE_STEPS): void {
    const currentValue = this.getShowCaseState();
    const newValue = currentValue.concat([step]);
    localStorage.setItem(this.SHOWCASE_STEPS_KEY, JSON.stringify(newValue));
  }

  static finishShowCase(): void {
    const stepsAreFinished = this.stepsAreFinished();
    const showCaseHasFinished = this.showCaseHasFinished();
    if (stepsAreFinished && !showCaseHasFinished) {
      this.setShowCaseState(TRIAL_SHOW_CASE_STEPS.DISCOUNT);
    }
  }

  static showCaseHasFinished(): boolean {
    return this.stepIsCompleted(TRIAL_SHOW_CASE_STEPS.DISCOUNT);
  }

  static stepsAreFinished(): boolean {
    const currentCompletedCards = this.getShowCaseState();
    return currentCompletedCards.length >= this.NUMBER_OF_NEEDED_STEPS;
  }

  static percentageOfSteps(): number {
    return (
      (this.getShowCaseState().filter((step) => step !== TRIAL_SHOW_CASE_STEPS.DISCOUNT).length /
        this.NUMBER_OF_NEEDED_STEPS) *
      100
    );
  }

  static stepIsCompleted(step: TRIAL_SHOW_CASE_STEPS): boolean {
    const currentCompletedCards = this.getShowCaseState();
    return currentCompletedCards.some((stepCompleted) => stepCompleted === step);
  }

  static completeStep(step: TRIAL_SHOW_CASE_STEPS): void {
    const isPending = !this.stepIsCompleted(step);
    if (isPending && step !== TRIAL_SHOW_CASE_STEPS.DISCOUNT) {
      this.setShowCaseState(step);
    }
  }

  static getCurrentPeriodByEnrollmentStartDate(enrollmentStartDate: string): number {
    return enrollmentStartDate < this.TRIAL_CONTROL_DATE ? 0 : 1;
  }
}
